import { Box, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LOGIN_PAGE_ROUTE } from '../../../constants/routes.constants';
import { signOut } from '../../../store/auth/auth.action';
import { selectUserProfile } from '../../../store/auth/auth.selector';
import { UserBoxAvatar, UserBoxButton } from './user-box.styles';

const UserBox = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const userProfile = useSelector(selectUserProfile);

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        setAnchorEl(null);
        navigate(LOGIN_PAGE_ROUTE);
        dispatch(signOut());
    };

    const firsLetterUsername = userProfile?.username
        ? userProfile.username.substring(0, 1)
        : '';
    const firstLetter = userProfile?.first_name
        ? userProfile.first_name.substring(0, 1)
        : firsLetterUsername;
    const secondLetter = userProfile?.last_name
        ? ' ' + userProfile.last_name.substring(0, 1)
        : '';
    const textAvatar = `${firstLetter.toUpperCase()} ${secondLetter.toUpperCase()}`;

    return (
        <Fragment>
            {userProfile && (
                <Box>
                    <UserBoxButton onClick={handleMenu}>
                        <UserBoxAvatar>
                            <Typography fontWeight={500}>
                                {textAvatar}
                            </Typography>
                        </UserBoxAvatar>
                    </UserBoxButton>
                    <Menu
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleLogout}>Logout</MenuItem>
                    </Menu>
                </Box>
            )}
        </Fragment>
    );
};

export default UserBox;
